import React from 'react'
import {Menu} from '@components/common/base/menu/menu'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export interface MenuSimpleItemData {
  id: string
  icon?: TablerIcons | React.ReactElement
  title: string | React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  items?: MenuItemData[]
  customDropdown?: React.ReactNode | (() => React.ReactNode)
  popupMenu?: boolean
  tooltip?: React.ReactNode
  after?: React.ReactElement
}

export interface MenuSeparator {
  separator: true
  empty?: boolean
}

export interface MenuCustomItemData {
  id: string
  element: React.ReactNode
}

export type MenuItemData =
  | MenuSimpleItemData
  | MenuSeparator
  | MenuCustomItemData

export interface MultiMenuProps {
  items: MenuItemData[]
  disabled?: boolean
  className?: string
  onItemClicked?: () => void
  popupMenu?: boolean
}

export const SharedMultiMenu = (props: MultiMenuProps) => {
  return <Menu {...props} />
}
